import { createSelector } from 'reselect';

const documentDeleteData = state => state.documentDeletePopupData;

export const isDeleteDocumentPopupOpenedSelector = createSelector(
    documentDeleteData,
    (popupData) => popupData.isOpened,
);
